module.exports = __webpack_public_path__ + "static/media/positioningPlatformsOptimization-01.daf8a5be.png";